module.exports = __webpack_public_path__ + "media/images/icons/resize_icon-27b1238e6409783ec8ae899ff3d22cce.svg";